import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import logo from "../../assets/img/logo.png";
import frFlag from "../../assets/img/flag/fr.png";
import enFlag from "../../assets/img/flag/uk.png";

export default function Nav() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleLang = () => {
    const next = i18n.language === "fr" ? "en" : "fr";
    i18n.changeLanguage(next);
  };

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <nav className="Navbar">
      {/* Logo */}
      <Link to={"/"}>
        <img src={logo} alt="Logo" />
      </Link>

      {/* Desktop links (unchanged) */}
      <ul className="Navbar-links">
        <li>
          <Link to="/">{t("nav.home")}</Link>
        </li>
        <li>
          <Link to="/about">{t("nav.about")}</Link>
        </li>
        <li>
          <Link to="/awakening">{t("nav.awakening")}</Link>
        </li>
        <li>
          <Link to="/contact">{t("nav.contact")}</Link>
        </li>
      </ul>

      {/* Desktop language toggle (unchanged) */}
      <button onClick={toggleLang} className="lang-toggle">
        <img
          src={i18n.language === "fr" ? frFlag : enFlag}
          alt={
            i18n.language === "fr" ? "Switch to English" : "Passer en français"
          }
          style={{ width: 30, height: "auto" }}
        />
      </button>

      {/* Burger button (mobile only) */}
      <button
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile menu sliding down */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li onClick={() => setMenuOpen(false)}>
            <Link to="/">{t("nav.home")}</Link>
          </li>
          <li onClick={() => setMenuOpen(false)}>
            <Link to="/about">{t("nav.about")}</Link>
          </li>
          <li onClick={() => setMenuOpen(false)}>
            <Link to="/awakening">{t("nav.awakening")}</Link>
          </li>
          <li onClick={() => setMenuOpen(false)}>
            <Link to="/contact">{t("nav.contact")}</Link>
          </li>
        </ul>
        <button onClick={toggleLang} className="lang-toggle mobile">
          <img
            src={i18n.language === "fr" ? frFlag : enFlag}
            alt={
              i18n.language === "fr"
                ? "Switch to English"
                : "Passer en français"
            }
            style={{ width: 30, height: "auto" }}
          />
        </button>
      </div>
    </nav>
  );
}
